export function ImprovementsReportPage() {
  return `
<div class="hero">
  <div class="hero-content">
    <h1 class="hero-title">About personalized advisory reports</h1>
    <p class="hero-subtitle">Discover what our report includes and how it can help you save</p>
  </div>
</div>

<section class="section bg-gray-50">
  <div class="container">
    <div class="max-w-6xl mx-auto prose prose-lg">
      <div class="flex flex-col md:flex-row md:items-start md:space-x-8">

        <div class="bg-white p-8 rounded-lg shadow-sm md:w-2/3">

          <h2 class="text-2xl text-blue-900 mb-4">Improve the energy performance of your home or building in Spain</h2>

          <p>Do you want to improve the energy performance (EP) of your home or commercial property in Spain? Would you like to know which measures fit your situation and what performance they can offer? Then request personalized advice from one of the accredited energy advisors at EPCspainhomes.com!</p>

          <p>One of our certified advisors will visit you in Spain to prepare a personalized recommendation report. You will receive clear information about the building and installation improvements that will make your home more efficient, comfortable, and healthy, and better adapted to the warm Spanish climate. The report contains a clear summary of the best measures for your case, including costs and payback times.</p>

          <p class="mt-2 font-medium flex items-center gap-2">
            <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
            </svg>
            <span>Want to know more? Below we explain everything about advisory reports for homes and commercial buildings in Spain.</span>
          </p>

          <h3 class="text-xl text-blue-900 mt-6 mb-2">What is personalized advice?</h3>
          <p>Personalized advice is a detailed energy improvement plan prepared by an accredited energy advisor. During the inspection, the advisor evaluates both the building condition and the installations (such as air conditioning, boilers, heating, and ventilation).</p>

          <p>Based on this, you will receive a report with concrete recommendations, such as:</p>
          <ul>
            <li>insulation of facade, roof, and floor (also important for heat protection);</li>
            <li>improvements in ventilation and shading systems for a healthier indoor climate;</li>
            <li>optimization or replacement of air conditioning systems or heat pumps;</li>
            <li>and the application of solar panels or thermosiphons for renewable energy.</li>
          </ul>

          <p>The advice follows the principle of the Trias Energetica:</p>
          <ul>
            <li>Reduce energy consumption – for example with insulation or solar protection.</li>
            <li>Use sustainable energy – such as a heat pump or a solar thermosiphon.</li>
            <li>Generate renewable energy – for example with solar panels.</li>
          </ul>

          <p>Personalized advice is always combined with a Spanish Energy Performance Certificate. This certificate shows the current energy situation (the initial measurement), while the advice shows how to improve it.</p>

          <p class="mt-2 font-medium">💡 Note: the rule also applies in Spain — insulate first, and only then invest in solar panels or heat pumps. Without good insulation, much of the energy is lost and the performance is low.</p>

          <h3 class="text-xl text-blue-900 mt-6 mb-2">What does personalized advice offer?</h3>
          <p>Personalized advice gives you a clear view of:</p>
          <ul>
            <li>the recommended measures, with costs and payback times;</li>
            <li>which measures are most profitable in the Spanish climate;</li>
            <li>the expected improvement of your energy certificate;</li>
            <li>and the effects on indoor comfort, thermal regulation, and humidity control.</li>
          </ul>

          <p>In addition, this type of report is often accepted by banks for green mortgage or energy renovation loan applications. This way you know exactly what is possible and what investment is required.</p>

          <p>Our advisors are completely independent and are not tied to suppliers or installers. You decide with which local company you want to implement the recommended measures.</p>

          <h3 class="text-xl text-blue-900 mt-6 mb-2">How to request personalized advice?</h3>
          <p>Do you want to know how efficient your home or building in Spain is? Through our comparison tool you can easily request personalized advice by selecting the option “Energy Certificate + Personalized Advice”.</p>

          <p>The energy certificate is the starting point (the initial measurement). While the certificate is normally the end point, in personalized advice it is precisely the start of improvement.</p>

          <p class="mt-2 font-medium">📍 Request your personalized advice for Spain here!</p>

          <h3 class="text-xl text-blue-900 mt-6 mb-2">Frequently asked questions about personalized advice</h3>
          <p>Do you have questions about personalized advice in Spain? Check our summary with the most frequently asked questions. Still need help?</p>

          <p class="mt-2">Contact our team:<br>📧 info@EPCspainhomes.com</p>

        </div>

        <div class="p-8 rounded-lg shadow-sm md:w-1/3" style="background: linear-gradient(335deg, rgba(63, 137, 233, 0.85), rgba(121, 211, 238, 0.75));">
          <img src="/images/team/compare.webp" alt="Compare energy certificate advisors" class="mb-4 w-full h-auto rounded-md object-cover" />
          <p class="mb-4">Compare energy certificate advisors.
Compare prices, quality, and speed based on your data.</p>

          <p><a href="/cadastro/" data-route="/cadastro/" class="btn bg-green-500 text-white px-6 py-3 rounded-lg font-medium inline-block">Compare now -></a></p>
        </div>

      </div>
    </div>
  </div>
</section>
      
<section class="section bg-blue-600 text-white">
  <div class="container text-center">
    <h2 class="text-3xl font-bold mb-4">Would you like to receive your personalized report?</h2>
    <p class="text-xl mb-8 opacity-90">Get specific recommendations for your home and discover how much you can save</p>
    <button class="btn bg-white text-blue-600 hover:bg-gray-100" data-route="/book-epc/">Request EPC Certificate</button>
  </div>
</section>

  `;
}
